import React, { FC, Fragment } from 'react';
import { isChowdeckOrder } from 'utils/functions';
import { BrandType, SearchType } from 'utils/types';
import { DropdownItem } from '@cokitchen/cokitchen-components';
import ChowdeckIcon from 'assets/images/chowdeck.png';
import { ENUM_BRAND_TYPE } from 'utils/enum';
import { ReactComponent as GlovoIcon } from 'assets/icons/glovo-icon.svg';
import { ReactComponent as ManoIcon } from 'assets/icons/mano-icon.svg';

type MoveBrandOptions = {
  data: BrandType | SearchType;
  onMove: (type: ENUM_BRAND_TYPE) => void;
};
const MoveBrandOptions: FC<MoveBrandOptions> = ({ data, onMove }) => {
  const { archived, brand_type, is_private } = data;

  return is_private && !archived && brand_type ? (
    <Fragment>
      {!isChowdeckOrder(brand_type) && (
        <DropdownItem className='min-h-[38px]' onClick={() => onMove(ENUM_BRAND_TYPE.CHOWDECK)}>
          <div className='flex gap-3 items-center text-sm'>
            <div className='bg-white border-[0.6px] border-[#EAEAEB] rounded-full m-aut0 shadow-md '>
              <img
                alt='icon'
                className='w-5 h-5 rounded-full border border-[#E9ECEC] object-cover'
                src={ChowdeckIcon}
              />
            </div>
            <p> Move to Chowdeck</p>
          </div>
        </DropdownItem>
      )}
      <DropdownItem className='min-h-[38px]' onClick={() => onMove(ENUM_BRAND_TYPE.GLOVO)}>
        <div className='flex gap-3 items-center text-sm'>
          <div className='bg-white border-[0.6px] border-[#EAEAEB] rounded-full m-aut0 shadow-md '>
            <GlovoIcon />
          </div>
          <p> Move to Glovo</p>
        </div>
      </DropdownItem>
      <DropdownItem
        className='min-h-[38px] cursor-not-allowed opacity-50'
        onClick={() => onMove(ENUM_BRAND_TYPE.MANO)}>
        <div className='flex gap-3 items-center text-sm'>
          <div className='bg-white border-[0.6px] border-[#EAEAEB] rounded-full m-aut0 shadow-md '>
            <ManoIcon />
          </div>
          <p> Move to Mano</p>
        </div>
      </DropdownItem>
    </Fragment>
  ) : null;
};

export default MoveBrandOptions;
